export enum Cookie {
  _UUID = '_UUID',
  BROWSER_GEOLOCATION = 'browserGeoLocation',
  CLICK_AND_COLLECT_STORE = 'clickandcollectstore',
  CONSENT_SETTING = 'consent_setting',
  FREDHOPPER_SEGMENT = 'fredhopperSegment',
  LEVEL = 'cookieLevel',
  STATE_GUARD = 'stateGuard',
  IS_BASKET_REMINDER_CALLED = 'isBasketReminderCalled',
}

export enum ABTestCookie {
  AI_SEARCH = 'aisearch',
  PRODUCT_BUNDLES = 'productbundles',
  BASKET_REMINDER_NOTIFICATION = 'basketremindernotificationgroup',
  EMBEDDED_CONTENT = 'embeddedcontentgroup',
  MOBILE_NAVIGATION = 'mobilenavigationgroup',
  DISABLE_AMEX_PAYMENT = 'amexgroup',
  HIDE_ADDITIONAL_PRODUCT_SELECTOR = 'hideAdditionalProductSelector',
  HIDE_BUNDLE_DEAL = 'hideBundleDeal',
  VISUALIZE_BOTH_DELIVERY_PROMISES = 'abgroup_visualize-both-delivery-promises',
  PDP_ANDES = 'abgroup_pdpandes',
  PDP_CAROUSEL = 'abgroup_pdpcarousel',
}

export enum ABTestCookieValue {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum CookieConsentSettingState {
  OLD_COMPONENT,
  NO_CONSENTS_AVAILABLE,
  CONSENTS_AVAILABLE,
}

export enum CookieConsentGroups {
  FUNCTIONAL = 'functional',
  ANALYTICS = 'analytics',
  MARKETING = 'marketing',
}

export enum StateGuardEnum {
  NEWSLETTER_SUBSCRIPTION = 'newsletter_subscription',
  AUTHENTICATED = 'authenticated', // This can be used to access account pages when logged in.
}

export enum CookieLevel {
  LEVEL_ZERO = 0,
  LEVEL_ONE = 1,
  LEVEL_TWO = 2,
}
